export interface Partner {
  id: string
  name: string
  logo: string
}

export const partners: Partner[] = [
  { id: 'p1', name: 'Intelbras', logo: 'https://static.lumi.new/ab/ab543e18271307e8c78a905fbc7f0bbc.png' },
  { id: 'p2', name: 'Hikvision', logo: 'https://static.lumi.new/67/671abca7aaa73d12b0454dfd2d1c7096.png' },
  { id: 'p3', name: 'Control iD', logo: 'https://static.lumi.new/00/009e4c20d3c5f4266f398dff5e545914.png' },
  { id: 'p4', name: 'Ubiquiti', logo: 'https://static.lumi.new/7b/7bf6901e6f1e72922174d78504188a69.png' },
  { id: 'p5', name: 'Furukawa', logo: 'https://static.lumi.new/83/8300c4b09baa8aac0209b19ed55fea81.png' },
  { id: 'p6', name: 'Garen', logo: 'https://static.lumi.new/3c/3c251d68946c3ff5d2d7d5d8ffa76c14.png' },
  { id: 'p7', name: 'PPA', logo: 'https://static.lumi.new/96/963e208da3ad3922e58f2f3f3ea39f0b.png' },
  { id: 'p8', name: 'Nice', logo: 'https://static.lumi.new/87/8790b61c91ac594be168c3eed57983a3.png' },
]

export interface ClientLogo {
  id: string
  name: string
}

export const clients: ClientLogo[] = [
  { id: 'cl1', name: 'Boticário' },
  { id: 'cl2', name: 'Bradesco' },
  { id: 'cl3', name: 'Elofarma' },
  { id: 'cl4', name: 'Unilider' },
  { id: 'cl5', name: 'CBF' },
  { id: 'cl6', name: 'Botafogo F.R.' },
]
